import { ReferentialKey } from 'api/referential';
import { useAppDispatch } from 'app/hooks';
import { SimpleDashboardContent } from 'features/dashboard/DashboardContent';
import { getMultipleReferentialsByKeys } from 'features/referentials/slices/getMultipleReferentialsByKeysThunk';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Workflow } from 'lucide-react';
import { GenericViewHeader } from 'back-office/shared/components/GenericViewHeader';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { NsKey } from 'enums/NsKey';

export default function FunnelsView() {
  const { t } = useDynamicTranslation([NsKey.Common])
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getMultipleReferentialsByKeys([
      ReferentialKey.Plateforme,
    ]));
  }, [dispatch]);

  return (
    <SimpleDashboardContent>
      <GenericViewHeader
        title={t("SIDEBAR.FUNNELS_MANAGER")}
        icon={Workflow}
      />
      <Outlet />
    </SimpleDashboardContent>
  );
}
